(() => {
  if (window.CFACartRewards) return;
  const thresholds = [25000, 50000, 75000, 100000];
  function calculate(state) {
    const spend = Math.max(0, Number(state.spend) || 0);
    const rate = spend >= 100000 ? 10 : spend >= 75000 ? 5 : spend >= 25000 ? 2.5 : 0;
    const next = thresholds.find(value => value > spend && (value !== 50000 || !state.shippingExcluded && state.hasShipping));
    return { spend, rate, next, remaining: next ? next - spend : 0, progress: Math.min(100, spend / 1000) };
  }
  window.CFACartRewards = { calculate };
  if (typeof document === 'undefined') return;
  let state, requestNumber = 0, controller;
  const stateContainer = () => document.querySelector('[data-rewards-state-container]');
  const money = cents => new Intl.NumberFormat('en-AU', {style:'currency', currency:'AUD', maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
  function render(widget) {
    if (!state) return;
    widget.hidden = !(state.enabled || state.preview) || !state.itemCount || state.currency !== 'AUD' || state.spend <= 0;
    if (widget.hidden) return;
    const result = calculate(state);
    const nextLabel = result.next === 50000 ? 'reach free shipping eligibility' : `unlock ${result.next === 25000 ? '2.5' : result.next === 75000 ? '5' : '10'}% off`;
    let message = result.next ? `Add ${money(result.remaining)} to ${nextLabel}.` : 'Maximum reward tier reached: 10% off.';
    if (result.rate && result.next) message = `${result.rate}% tier reached. ${message}`;
    if (state.preview && !state.enabled) message = `Preview · ${message}`;
    widget.querySelector('[data-rewards-message]').textContent = message;
    widget.querySelector('[data-rewards-fill]').style.width = `${result.progress}%`;
    const progress = widget.querySelector('[role="progressbar"]');
    progress.setAttribute('aria-valuenow', Math.min(1000, result.spend / 100));
    progress.setAttribute('aria-valuetext', `${money(result.spend)} qualifying spend. ${message}`);
    widget.querySelectorAll('[data-threshold]').forEach(node => node.classList.toggle('is-reached', result.spend >= Number(node.dataset.threshold) && (Number(node.dataset.threshold) !== 50000 || !state.shippingExcluded && state.hasShipping)));
    const saving = widget.querySelector('[data-rewards-saving]');
    saving.hidden = !state.saving;
    saving.textContent = `Cart reward applied: −${money(state.saving)}`;
    widget.querySelector('[data-rewards-shipping]').textContent = !state.hasShipping ? 'Delivery is not required for these items.' : state.shippingExcluded ? 'This cart includes items or weight excluded from free shipping. Delivery charges apply.' : result.spend >= 50000 ? 'Free Australian standard shipping threshold reached. Weight, item and destination eligibility apply.' : 'Free standard Australian shipping on eligible orders $500+.';
  }
  function renderAll() { document.querySelectorAll('cfa-cart-rewards').forEach(render); }
  function readState(root = document) {
    const script = root.querySelector('[data-rewards-state]');
    if (!script) throw new Error('Cart rewards state missing');
    state = JSON.parse(script.textContent); renderAll();
  }
  async function refresh() {
    const current = ++requestNumber; controller?.abort(); controller = new AbortController();
    const container = stateContainer(); if (!container) return;
    document.querySelectorAll('cfa-cart-rewards').forEach(node => { node.hidden = true; });
    try {
      const url = new URL(container.dataset.root, location.origin); url.searchParams.set('section_id', container.dataset.sectionId);
      const response = await fetch(url, {signal:controller.signal, cache:'no-store'});
      if (!response.ok) throw new Error('Cart refresh failed');
      const html = await response.text(); if (current !== requestNumber) return;
      readState(new DOMParser().parseFromString(html, 'text/html'));
    } catch (error) { if (error.name !== 'AbortError') document.querySelectorAll('cfa-cart-rewards').forEach(node => { node.hidden = true; }); }
  }
  class Rewards extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const toggle = this.querySelector('[data-rewards-toggle]');
      let collapsed = false; try { collapsed = this.hasAttribute('data-floating') && sessionStorage.getItem('cfa-rewards-collapsed') === 'true'; } catch (_) {}
      const setCollapsed = value => { this.querySelector('[data-rewards-details]').hidden = value; toggle.textContent = value ? 'Show details' : 'Hide details'; toggle.setAttribute('aria-expanded', String(!value)); };
      setCollapsed(collapsed);
      toggle.addEventListener('click', () => { collapsed = !collapsed; setCollapsed(collapsed); if (this.hasAttribute('data-floating')) try {sessionStorage.setItem('cfa-rewards-collapsed', String(collapsed));} catch (_) {} }, {signal:this.abort.signal});
      render(this);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('cfa-cart-rewards', Rewards);
  try { readState(); } catch (_) { refresh(); }
  document.addEventListener('cart:prepare-bundled-sections', event => { const id = stateContainer()?.dataset.sectionId; if (id && event.detail.sections.length < 5 && !event.detail.sections.includes(id)) event.detail.sections.push(id); });
  document.addEventListener('cart:change', event => {
    ++requestNumber; controller?.abort();
    const id = stateContainer()?.dataset.sectionId, html = event.detail?.cart?.sections?.[id];
    if (html) { try {readState(new DOMParser().parseFromString(html, 'text/html'));} catch (_) {refresh();} } else refresh();
  });
  document.addEventListener('cart-drawer:refreshed', renderAll);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  const updateObscured = () => { const floating = document.querySelector('cfa-cart-rewards[data-floating]'); if (floating) floating.toggleAttribute('data-obscured', !!document.querySelector('cart-drawer[open], quick-buy-drawer[open], .product-sticky-bar.is-visible')); };
  new MutationObserver(updateObscured).observe(document.body, {subtree:true, attributes:true, attributeFilter:['open','class']});
  updateObscured();
})();
